import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';

/* CSS Modules */
import shared from '../styles/shared.module.css';
import styles from './SettingsPage.module.css';

/* Context */
import { useAuthContext } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';

/* Individual sections */
import MyProfile from '../components/settings/MyProfile';
import AccountSettings from '../components/settings/AccountSettings';

/* Icons */
import chevron from '../assets/icons/chevron_down.svg'

/* Confirmation Card */
import ConfirmationModal from '../components/cards/ConfirmationModal';

const SettingsPage = () => {

    const navigate = useNavigate();

    const { logout } = useAuthContext();
    const { showToast } = useToast();

    // Track which section is active
    const [activeSection, setActiveSection] = useState('profile');
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const handleDeleteAccount = async () => {
        try {
            await api.delete('/auth/delete-account');
            showToast('Account deleted. Farewell my friend.', 'success');
            logout();
            navigate('/login');
        } catch (error) {
            console.error("Error deleting account:", error);
            showToast('Could not delete account. Please try again.', 'error');
        }
    };

    return (
        <div>
            {/* Page header */}
            <section className={shared.heroHeader}>
                <div>
                    {/* Page title */}
                    <h1 className={shared.heroTitle}>Settings</h1>
                    <p className={shared.heroSubtitle}>Configure your own TravelBuddy</p>
                </div>
            </section>

            {/* Main Layout: Sidebar + Content */}
            <div className={styles.settingsContainer}>

                {/* Sidebar navigation */}
                <aside className={styles.settingsSidebar}>
                    <button
                        className={`${styles.settingsNavItem} ${activeSection === 'profile' ? styles.active : ''}`}
                        onClick={() => setActiveSection('profile')}
                    >
                        My Profile
                    </button>

                    <button
                        className={`${styles.settingsNavItem} ${activeSection === 'account' || activeSection === 'password' ? styles.active : ''}`}
                        onClick={() => setActiveSection('account')}
                    >
                        Account & Password
                    </button>
                </aside>

                {/* Vertical Divider Line */}
                <div className={styles.settingsDivider}></div>

                {/* Active Content Area */}
                <div className={styles.settingsContent}>
                    {activeSection === 'profile' &&
                        <div>
                            <h3 className={styles.settingsContentTitle}>My Profile</h3>
                            <MyProfile />
                        </div>
                    }

                    {activeSection === 'account' &&
                        <div>
                            <h3 className={styles.settingsContentTitle}>Account & Password</h3>

                            <button
                                className={styles.accountPasswordButton}
                                onClick={() => setActiveSection('password')}
                            >
                                Change password
                                <img src={chevron} alt='Change Password' className={styles.accountPasswordChevron} />
                            </button>

                            <button
                                className={styles.accountPasswordButton}
                                onClick={() => setShowDeleteModal(true)}
                            >
                                Delete account
                                <img src={chevron} alt='Delete account' className={styles.accountPasswordChevron} />
                            </button>
                        </div>
                    }

                    {activeSection === 'password' &&
                        <div>
                            <h3 className={styles.settingsContentTitle}>Change Password</h3>
                            <AccountSettings />
                        </div>
                    }
                </div>
            </div>

            {/* --- MODAL: DELETE CONFIRM --- */}
            <ConfirmationModal
                isOpen={showDeleteModal}
                title="Delete your account?"
                message="You will not be able to recover any information once you have deleted this account. If you wish to use TravelBuddy again, you will have to create a new account and sign up as a brand new user."
                onClose={() => setShowDeleteModal(false)}
                onConfirm={handleDeleteAccount}
                confirmText="Delete"
                cancelText="Cancel"
                isDanger={true}
                showCancel={true}
            />
        </div>
    );
};

export default SettingsPage;